import { UPDATE } from 'react-admin';

export const REISSUE_TICKET = 'REISSUE_TICKET';
export const reissueTicket = (id, data, basePath) => ({
    type: REISSUE_TICKET,
    payload: { id, data: { ...data, issued_at: '' } },
    meta: { fetch: UPDATE, resource: 'tickets' },
});